<template>
  <div class="comment-dialog-container" @touchmove.prevent v-if="state">
    <div class="comment-mask" v-show="state" @click="handleClose"></div>
    <div class="comment-dialog-content flex-column"
         :class="[{'android-browser': isAndroidBrowser}, {'comment-dialog-content-show': state}]">
      <p class="user-name" v-if="operationComment.user">评论给 <span>{{getUserName}}</span></p>
      <div class="comment-footer flex">
        <w-textarea v-model="commentText" placeholder="友善的沟通是交流的开始" ref="textArea" :line-height="20"
                    :fontMaxSize="300" style="flex: 1;border: none" :autofocus="true"></w-textarea>
        <div class="sub-btn" @click="sendComment" >发送</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {envMixin} from '../../../assets/js/mixin/global'
  import WTextarea from "../../../components/global/w-auto-textarea"

  export default {
    name: 'comment-dialog',
    mixins: [envMixin],
    props: {
      state: {
        type: Boolean,
        default: false
      },
      operationComment: {
        type: Object,
        default: () => {
          return {}
        }
      },
      author: [Number, Object]
    },
    data() {
      return {
        commentText: '',
        height: 20
      }
    },
    mounted() {
      // 解决评论dialog组件中的textarea无法滑动
      window.addEventListener('touchmove', function (e) {
        let target = e.target
        if (target && target.tagName === 'TEXTAREA') {
          e.stopPropagation();
        }
      }, true)
      // this.onFocus()
    },
    computed: {
      getUserName() {
        let isAuthor = false
        if (this.author.id != null) {
          if (this.author.id == this.operationComment.user.id) {
            isAuthor = true
          }
        } else {
          if (this.author.username == this.operationComment.user.username && this.author.avatar_url == this.operationComment.user.avatar_url) {
            isAuthor = true
          }
        }
        return (this.operationComment.user.username || '超级简历用户') + (isAuthor ? '  (作者)' : '')
      },
      rows() {
        let height = this.height
        if (height <= 20) {
          return 1
        } else if (height <= 40 && height > 20) {
          return 2
        } else if (height <= 60 && height > 40) {
          return 3
        } else if (height > 60) {
          return 4
        }
      }
    },
    watch: {
      // state(value) {
      //   if (value) {
      //     this.onFocus()
      //   }
      // }
    },
    components: {WTextarea},
    methods: {
      // 输入字数检查
      inputCheck({target}) {
        // console.log(this.height)
        if (this.commentText.length >= 301) {
          this.$createToast({
            txt: '超出评论字数限制',
            time: 1500,
            type: 'txt'
          }).show()
          setTimeout(() => {
            this.commentText = this.commentText.slice(0, 300)
          }, 100)
        }
      },
      handleClose() {
        this.$emit('handleClose')
        // this.commentText = ''
      },
      sendComment() {
        if(!this.commentText){
          this.$createToast({
            txt: '评论内容为空',
            time: 1000,
            type: 'warn'
          }).show()
          return
        }

        this.$emit('sendComment', this.commentText)
      },
      highLight(content) {
        let arr = []
        let con = content.split('\n').forEach(item => arr.push(`<p>${item.trim()}</p>`))
        return arr.join('')
      },
    }
  }
</script>
<style lang="scss">
</style>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/variable";
  @import "../../../assets/scss/global/mixin";
  /deep/ .textarea-content{
    outline: none;
  }
  .sub-btn {
    width: 60px;
    text-align: center;
    color: #4183FF;
    font-size: 14px;
    line-height: 24px;
    height: 24px;
  }

  .comment-dialog-container {
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 339;
    height: 100%;
    //height:$screen-height;


    .comment-mask {
      position: fixed;
      height: 100vh;
      width: 100vw;
      top: 0;
      left: 0;
      z-index: 312;
      background-color: rgba($color: #000, $alpha: .5);
    }

    .comment-dialog-content {
      position: absolute;
      transform: translateX(100%);
      bottom: 0px;
      z-index: 313;
      padding: 16px 0px 16px 24px;
      background-color: $color-light;
      width: 100vw;

      .user-name {
        margin-bottom: 16px;
        color: #9C9C9C;
        font-size: $font-size-small;

        .high-light {
          color: #4183FF;
        }
      }

      /deep/ .comment_text_area {
        border: none !important;
        height: 80px;

        textarea {
          padding: 12px 16px;
          background-color: #F9F9F9;
        }
      }

      /deep/ .comment_text_area:after {
        border: none !important;
      }


      .comment-footer {
        margin-bottom: 10px;
        color: #669BFF;
        margin-right: 24px;
        align-items: flex-end;
        .send-btn {
          width: 66px;
          height: 104px;
          background-color: $color-light;
          color: #4183ff;
          outline: none;
          border: none;
          font-size: $font-size-medium-x;

          &:disabled {
            color: #4183FF;
            opacity: .6;
          }
        }
      }
    }

    .comment-dialog-content-show {
      transform: translateX(0);
    }

    .android-browser {
      position: fixed;
    }
  }
</style>
